import { Stack, Typography } from "@mui/material";
import SleepCard from ".";

export default function SleepCardExamples() {
  return (
    <Stack gap={3} width="100%">
      <Typography variant="h6" fontWeight={600}>
        Healthy (&gt;9 hours)
      </Typography>
      <SleepCard hoursPerNight={9.5} lastUpdated="2025-02-23T00:00:00Z" />

      <Typography variant="h6" fontWeight={600}>
        Needs Attention (7–9 hours)
      </Typography>
      <SleepCard hoursPerNight={8} lastUpdated="2025-02-23T00:00:00Z" />

      <Typography variant="h6" fontWeight={600}>
        Needs Support (&lt;7 hours)
      </Typography>
      <SleepCard hoursPerNight={6} lastUpdated="2025-02-23T00:00:00Z" />
    </Stack>
  );
}
